"use client"
/* */
const getInitialsFromString = (initials) => {
  return initials.replace(/[^\p{L}\s]/giu, "").split(" ").map((part) => part.trim()[0]).filter((p) => p !== void 0).map((char) => char.toUpperCase()).slice(0, 2);
};

export { getInitialsFromString };
//# sourceMappingURL=getInitialsFromString.mjs.map
